import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { IEnrollMFAPayload, IFriendlyNamePayload, IMFAData, IMFAInitiatePayload } from '../model/IMfa.model';
import { catchError } from 'rxjs/operators';
import { createHttpResponseAppError } from 'src/app/service/cidaas-api.service';
import { IResponse } from '../model/IResponse.model';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient) { }

  _initiateVerification = (trackId:string, method:string, payload?:IMFAInitiatePayload) =>{
    return this.http.post<IResponse<IMFAData>>(`${environment.base_url}/verification-actions-srv/setup/${method}/initiate/${trackId}`, payload?payload:{}).pipe(
      catchError((err) => { throw createHttpResponseAppError(err);})
    )
  }

  _configureVerification = (payload: IEnrollMFAPayload, method: string) => {
    return this.http.post<any>(`${environment.base_url}/verification-actions-srv/setup/${method}/verification`, payload).pipe(
      catchError((err) => { throw createHttpResponseAppError(err);})
    );
  };

  _configureFriendlyName = (payload: IFriendlyNamePayload, track_id:string, method:string) => {
    return this.http.put<any>(`${environment.base_url}/verification-actions-srv/setup/users/friendlyname/${method.toUpperCase()}/${track_id}`, payload);
  };

  _listenSocket = (status_id:string) =>{
    return this.http.post<any>(`${environment.base_url}/verification-srv/v2/notification/status/${status_id}`, {});
  }

  _userActionOnEnrolment = (track_id:string, action:string) =>{
    return this.http.post<any>(`${environment.base_url}/auth-actions-srv/validation/${track_id}`, {action:action});
  }
}
